const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787'

export function isServiceUnavailableError(data: unknown): boolean {
  return !!data && typeof data === 'object' && 'code' in data && data.code === 'SERVICE_REGION_UNAVAILABLE'
}

export async function isServiceUnavailable(): Promise<boolean> {
  try {
    const response = await fetch(`${API_URL}/auth/availability`, {
      cache: 'no-store', signal: AbortSignal.timeout(5000),
    })
    return response.status === 403 && isServiceUnavailableError(await response.json())
  } catch {
    // A connection failure is not a country restriction. Normal requests still
    // enforce the policy on the server and display their own connection errors.
    return false
  }
}

export function showServiceUnavailable(data: unknown): void {
  if (!isServiceUnavailableError(data)) return
  // Background session restoration must not hide legal/deletion pages.
  const path = window.location.pathname
  if (['/service-unavailable', '/privacy', '/terms', '/account-deleted'].includes(path) || path === '/account/delete/confirm') return
  window.location.replace('/service-unavailable')
}
